import React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes';
import {
    CourseWorkSubmissionCard,
    ReviewCompleteBadge,
} from '../../molecules/course_work_submissions/CourseWorkSubmissionCard';
import './examPracticalSectionSubmissionForOthersListItem.module.scss';
import { observer } from 'mobx-react';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SubmitterLabel } from '../../molecules/course_work_submissions/SubmitterLabel';
import { PracticalSectionSubmissionIndexView } from '../../../types/practical_section_submmission';

type Props = {
    submission: PracticalSectionSubmissionIndexView;
};

export const ExamPracticalSectionSubmissionForOthersListItem = observer(({ submission }: Props) => {
    const { isSp } = useViewportState();
    return (
        <CourseWorkSubmissionCard
            metaAttributes={{ 'data-submission-type': 'exam_practical_section', 'data-submission-id': submission.id }}
            badge={submission.review_completed_at && <ReviewCompleteBadge />}
            submissionCreatedAt={submission.created_at}
            onClick={
                isSp
                    ? () => GlobalStatesV3.routing.push(V3Routes.examPracticalSectionSubmissionShow(submission.token))
                    : undefined
            }
        >
            <div styleName="body">
                <div styleName="header">卒業制作</div>
                <div styleName="title">{submission.section.title}</div>
                <div styleName="description">{submission.section.description}</div>
                <div styleName="bottom-tools">
                    <SubmitterLabel submitter={submission.user} />
                    <Button
                        type="normal"
                        to={V3Routes.examPracticalSectionSubmissionShow(submission.token)}
                        styleName="link-button"
                        className="link-button"
                    >
                        提出内容を確認する
                    </Button>
                </div>
            </div>
        </CourseWorkSubmissionCard>
    );
});
